import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import { PDPInternalState, PDPSwarovskiProductVariantFrontend } from "./PDP_SingleImageCarousel/state/types";

export function usePdpUrlState(
  variantExactMatchFromPicker: PDPSwarovskiProductVariantFrontend,
  variantSelectionMethod: PDPInternalState["variantSelectionMethod"],
) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (variantSelectionMethod === "auto-selected") {
      return;
    }

    if (variantExactMatchFromPicker && location.pathname !== variantExactMatchFromPicker.path) {
      void navigate(
        {
          ...location,
          pathname: variantExactMatchFromPicker.path,
        },
        {
          replace: true,
          state:
            typeof location.state === "object" && location.state !== null
              ? { ...location.state, expectSimilarLayout: true }
              : { expectSimilarLayout: true },
        },
      );
    }
  }, [variantExactMatchFromPicker, variantSelectionMethod]);
}
